import { defineMessages } from "react-intl";

export const messages = defineMessages({
    timelineViewToggleLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-toggle.timeline",
        defaultMessage: "Timeline",
        description: "Label for toggling to the Jira Board Timeline View"
    },
    calendarViewToggleLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-toggle.calendar",
        defaultMessage: "Calendar",
        description: "Label for toggling to the Jira Board Calendar View"
    },
    selectBoardSplitButtonDropdownLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-dropdown.label",
        defaultMessage: "More Boards",
        description:
            "Label for opening a split button dropdown to select from more boards"
    },
    logoAltText: {
        id: "fastshift.migrations-management-page.jira-embed-view-title.logo-alt-text",
        defaultMessage: "Project Icon",
        description: "Alt Text for project icon for the selected board"
    },
    havingTroubleSubtext: {
        id: "fastshift.migrations-management-page.having-trouble-subtext",
        defaultMessage:
            "Having trouble viewing the plan? <Link>Log in to your project</Link> and refresh the page.",
        description:
            "Subtext for the migrations management page under the migration planner"
    }
});
